// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__xuu-l","modal__body":"Modal_modal__body__32C8P","modal__title":"Modal_modal__title__4Meg2","modal__close-icon-btn":"Modal_modal__close-icon-btn__8hkLW"};